import React from "react";

import { useWizard } from "../WizardContext";
import QuestionTitle from "../../elements/QuestionTitle";
import AmountField from "../../elements/AmountField";

const titles = {
  "1": "What is the value of the property you want to buy/search for?",
  "2": "What is the value of the plot you want to buy?",
  "3": "What is the construction cost?",
  "4": "What is the value of the property you want to complete?",
  "5": "What is the cost/budget for the required work?",
}

const HaveProperty = () => {
  const { responses } = useWizard();

  return (
    <>
      <QuestionTitle
        title={titles[responses["1"]?.AnswerId || "1"]}
        main
      />
      <AmountField itemId="3" />
    </>
  );
}

export default HaveProperty;
